import {
  type GroupButtonPeriodOption,
  GroupButtonPeriod as SharedGroupButtonPeriod,
} from 'src/components/GroupButtonPeriod';

export type Period = null | 180 | 90 | 30;
interface GroupButtonPeriodProps {
  periods?: GroupButtonPeriodOption<Period>[];
  selectedPeriod: Period;
  handlePeriodChange: (period: Period) => void;
}

const mappedPeriods: { period: Period; buttonText: string }[] = [
  null,
  180,
  90,
  30,
].map((period) => ({
  period: period as Period,
  buttonText: period ? `${period} dias` : 'Tudo',
}));

export function GroupButtonPeriod({
  periods = mappedPeriods,
  selectedPeriod,
  handlePeriodChange,
}: GroupButtonPeriodProps) {
  return (
    <SharedGroupButtonPeriod
      periods={periods}
      selectedPeriod={selectedPeriod}
      handlePeriodChange={handlePeriodChange}
    />
  );
}
